import { render, staticRenderFns } from "./course-case-detail.vue?vue&type=template&id=54ece002&scoped=true&"
import script from "./course-case-detail.vue?vue&type=script&lang=js&"
export * from "./course-case-detail.vue?vue&type=script&lang=js&"
import style0 from "./course-case-detail.vue?vue&type=style&index=0&id=54ece002&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ece002",
  null
  
)

export default component.exports